"use strict";
require('documenteditor/documenteditor');
require('common/directives/paginationDirective');
require('common/directives/checkboxGroupDirective');
var urls = require('common/urls');
var editCtrl = require('collection/controllers/editCtrl');
var showCtrl = require('collection/controllers/showCtrl');
var indexCtrl = require('collection/controllers/indexCtrl');
var workListCtrl = require('common/controllers/workListCtrl');
var navCtrl = require('common/controllers/navCtrl');
var app = angular.module('collection', ['documenteditor', 'paginationDirective', 'templates', 'checkboxGroupDirective', 'ngFlash', 'ui.bootstrap']);
app.controller('indexCtrl', ['$scope', '$rootScope', '$http', 'urls', 'permissions', indexCtrl]);
app.controller('editCtrl', ['$scope', '$rootScope', '$http', 'urls', 'id', 'values', 'Flash', '$timeout', 'permissions', editCtrl]);
app.controller('showCtrl', ['$scope', '$rootScope', '$http', 'urls', 'id', 'values', 'Flash', '$timeout', 'permissions', '$uibModal', showCtrl]);
app.controller('workListCtrl', ['$scope', '$rootScope', '$http', '$timeout', workListCtrl]);
app.controller('navCtrl', ['$scope', navCtrl]);
app.value('urls', urls);
module.exports = app;
